import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import facotImage from "../assets/images/meeting.jpg"; // Replace with the actual path to the uploaded image
import heroBg from "../assets/images/HeroBanner.png";
import "../styles/Facot.css";
import { useNavigate } from "react-router-dom";

const GuidelinesPage = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  const handleFacotClick = () => {
    // navigate("/facot-application-form");
    window.open(
      "https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/FACOTAPPLICATIONFORM.pdf",
      "_blank",
      "noopener,noreferrer"
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);
  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="main-section">
            <Container>
              <Row className="align-items-start mb-4">
                <h2 className="poppins-medium">
                  Guidelines & Eligibility Criteria for Award of Fellow of
                  Academic Council of Occupational Therapy (FACOT)
                </h2>
                  <Col lg={6}>
                    <p>
                      The Fellow of ACOT is awarded to professionals in the field
                      of Occupational Therapy for their outstanding contribution
                      to research and academics.
                    </p>
                    <ol>
                      <li>
                        A member of AIOTA with a minimum qualification of a
                        master's degree in Occupational Therapy from AIOTA
                        accredited OT college & who fulfills the laid down
                        eligibility credit points specified below, may apply to
                        the Dean of the Academic Council of Occupational Therapy,
                        on the prescribed form before 31st August of every year.
                      </li>
                      <li>
                        Only those members can apply for Fellow of ACOT whose
                        membership has not been withheld or suspended and there
                        have been no disciplinary proceedings against the member.
                      </li>
                      <li>
                        The Dean ACOT will scrutinize the application of the
                        member and on establishing the eligibility to become a
                        Fellow of ACOT, recommend the same to the EC of ACOT.
                      </li>
                      <li>
                        The recommendation of ACOT EC will be submitted to AIOTA
                        EC for final approval. ACOT would notify the decision of
                        AIOTA EC to the applicant.
                      </li>
                      <li>
                        The prescribed fee of INR 11,800- (including 18% GST)
                        only, shall be payable by the applicant after approval of
                        the award.
                        <ul>
                          <li>
                            The processing fee of Rs. 3540/- (including 18% GST)
                            should be sent by Demand draft/NEFT/Net banking along
                            with a duly-filled application form.
                          </li>
                          <li>
                            Balance amount of Rs. 8260/- (including 18% GST) to be
                            paid after the approval of the award.
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </Col>
                  <Col md={6} className="d-flex justify-content-end d-none d-lg-flex">
                    <img
                      src={facotImage}
                      alt="FACOT Award Ceremony"
                      className="vision-image"
                    />
                  </Col>
              </Row>
              <p>IMPORTANT:</p>
              <ol>
                <li>
                  The award committee will inform the office of submission &
                  submission of the application form.
                </li>
                <li>
                  Any contact about award information will be based on a duly
                  filled form.
                </li>
                <li>
                  The applicant must fulfill the following eligibility criteria
                  to submit request certificate must submit the application form
                  with self-attested copies supporting the award eligibility
                  criteria for award supporting self-attached copies document in
                  order that the applicant fulfilling the eligibility criteria
                  for the award is submitted.
                </li>
              </ol>

              <h3>Eligibility Criteria Points</h3>
              <h3>Section 1</h3>
              <div className="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Criteria</th>
                    <th>Credit Points</th>
                    <th>Maximum Credit Points</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>I</td>
                    <td>
                      Ref less than 15 years of continuous membership minimum
                      period
                    </td>
                    <td>17</td>
                    <td>17</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>
                      Minimum 3 publications as sole Contributor/author in the
                      indexed/recognized journals/international journals as per
                      ACOT guidelines
                    </td>
                    <td>12</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>
                      Indexed journal of related subjects, AIOTA magazine/books,
                      Case report, Research articles
                    </td>
                    <td>9</td>
                    <td>9</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>
                      PG students of OT in AIOTA accredited institutes students
                      of Masters
                    </td>
                    <td>5 points per student</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>
                      Minimum three presentations/One day seminar/Technical
                      Meeting over in the National/International conference as a
                      presentation organized seminars in a joint OT-CPMR
                      session/Workshop
                    </td>
                    <td>2 points each</td>
                    <td>6</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>
                      Organized seminars in a joint OT-CPMR session/in an
                      international conference of AIOTA resource person
                    </td>
                    <td>2 points each</td>
                    <td>6</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table-total-row">
                    <td colspan="4">
                      <div class="table-total">
                        <span>Total:</span>
                        <span class="total-value">50</span>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
              </div>

              <h3>Section 2</h3>
              <div className="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Criteria</th>
                    <th>Credit Points</th>
                    <th>Maximum Credit Points</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>I</td>
                    <td>
                      Completed PhD - OT in time course of minimum 3 years (PG)
                      norms
                    </td>
                    <td>1.5 points per year</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>
                      Masters in OT related subjects (minimum 3 years) (PG)
                      norms
                    </td>
                    <td>0.5 points each year</td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>Doctorate in related subjects (University)</td>
                    <td>1.5 points per year</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>
                      Published in the bulletin/occupational therapy (bulletin
                      AIOTA/AOTA)
                    </td>
                    <td>0.5 points each</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>WHO/other professional institute</td>
                    <td>0.5 points per year</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>
                      Designed/Teaching Clinical/Operational Therapy related
                      publications mentioned as per AIOTA WHO accredited
                      institute for B. Sc. OT & B. OT as a guest lecturer
                    </td>
                    <td>0.5 points every three years</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>
                      Completed graduate studies guide to AIOTA affiliated
                      institutions for B. Sc. OT
                    </td>
                    <td>1 point for each candidate</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>
                      Completed graduate studies guide to AIOTA accredited
                      institutions for Masters
                    </td>
                    <td>1.5 points for each candidate</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>
                      Every contribution to OT professor holding candidate
                      awards in AOTA recognized institutions/universities,
                      central/WHO international awards
                    </td>
                    <td>1 point each</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>
                      Edited the journal as editor-in-chief/edited book in last
                      10 years by AIOTA
                    </td>
                    <td>1 point each</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>
                      Received awards/data/honors pertaining to Occupational
                      Therapy service
                    </td>
                    <td>1 point each</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Contribution as co-author in the published journal</td>
                    <td>1 point each</td>
                    <td>2</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table-total-row">
                    <td colspan="4">
                      <div class="table-total">
                        <span>Total:</span>
                        <span class="total-value">50</span>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
              </div>

              <div className="additional-details">
                <p>
                  <strong>Total Credit Points & Eligibility</strong>
                  <br />
                  Total credit points from Section 1 & 2 ={" "}
                  <span className="highlight">50+50 = 100</span>
                  <span className="note">
                    {" "}
                    (out of 50 points, a minimum of 38 points are required from
                    section 1)
                  </span>
                </p>
                <p>
                  <strong>Candidate's minimum credit points:</strong>
                  <br />
                  Scoring of minimum credit points in section 1 should be:
                  <span className="highlight"> 38</span>
                </p>
              </div>

              {/* <Row className="d-flex justify-content-center">
                <Button
                  className="mt-5 facot-app-form-button"
                  onClick={handleFacotClick}
                >
                  FACOT Application Form
                </Button>
              </Row> */}
              <Row className="d-flex justify-content-center">
                <Button
                  className="mt-5 facot-app-form-button w-auto"
                  onClick={handleFacotClick}
                >
                  FACOT Application Form
                </Button>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default GuidelinesPage;
